import angular from 'angular';
import template from './asNavBar.component.html';
import style from './asNavBar.component.css';

export default angular.module('asNavBar', []).component('asNavBar', {
    template,
    style,
    controller(
        __env,
        asNavBarService,
        asNotifier,
        authenticationService,
        billingActionService,
        liveChatService,
        stateConstants,
        textResources,
        userAccessService,
        sessionService,
        sessionTypeConstants
    ) {
        var vm = this;

        vm.asNavBarService = asNavBarService;
        vm.cloudUrl = __env.cloudUrl;
        vm.userMenu = [
            {
                name: 'Logout',
                showHeader: false,
                items: [{ label: 'Logout', value: 'logout' }]
            }
        ];
        vm.showConsoleRedirect = true;

        vm.$onInit = () => {
            if (sessionService.getSessionType() == sessionTypeConstants.guest) {
                vm.showConsoleRedirect = false;
            }

            userAccessService
                .hasAccessTo(stateConstants.billing.overview.name)
                .then(
                    hasAccess => {
                        if (hasAccess) {
                            billingActionService.getGlobalActions().then(
                                actions => {
                                    var changeSubscriptionAction = actions.filter(
                                        a => a.action == 'subscription:change'
                                    )[0];

                                    if (changeSubscriptionAction) {
                                        vm.showUpgradeSubscription = true;
                                        vm.labelUpgradeSubscription =
                                            changeSubscriptionAction.label;
                                    }
                                },
                                () => {
                                    asNotifier.errorAndTryAgain(
                                        textResources.billingGetActionsFailed
                                    );
                                }
                            );
                        }
                    },
                    () => {
                        asNotifier.errorAndTryAgain(
                            textResources.getUserAccessFailed
                        );
                    }
                );
        };

        vm.initiateChat = () => {
            liveChatService.initiateChat();
        };

        vm.logout = () => {
            authenticationService.logout(true);
        };
    }
});



// WEBPACK FOOTER //
// ./modules/shared/asNavBar/asNavBar.component.js